module.exports = __webpack_public_path__ + "static/media/grand2.f3d30eb3.JPG";